import { useState } from "react";
import { cn } from "@somethings-ui/core";
import { Notes } from "./notes/notes";
import { Note } from "@/lib/api/notes";
import { MentorshipDetails } from "@/lib/api/mentorships";
import { Calendar } from "./calendar";
import { Contact } from "./contact";
import { User } from "@/lib/api/user";
import { Feedback } from "./feedback";
import { Session } from "@/lib/api/sessions";
import { MessageSearch } from "./message-search";

export type CustomTabsType = {
  icon: React.ReactNode;
  id: string;
  label: string;
};

export function CustomTabs({
  tabs,
  notes,
  mentorship,
  sessions,
  adminMode,
  supervisor,
}: {
  tabs: CustomTabsType[];
  notes: Note[];
  sessions: Session[];
  mentorship: MentorshipDetails;
  adminMode: boolean;
  supervisor: User | null;
}) {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  return (
    <div className="flex w-full flex-col">
      <nav className="w-full">
        <div className="no-scrollbar flex items-start gap-4 overflow-x-auto">
          {tabs.map((tab) => (
            <div
              className={cn(
                "cursor-pointer text-nowrap transition-opacity active:opacity-50 flex justify-center items-center gap-2 px-3 py-1.5 rounded-lg",
                {
                  "border border-[#E2E2E2]": tab.id !== activeTab,
                  "bg-[#F1F1F1] border border-[#F1F1F1]": tab.id === activeTab,
                }
              )}
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon}
              <div
                className={cn("text-base font-normal", {
                  "text-zinc-400": tab.id !== activeTab,
                  "text-black": tab.id === activeTab,
                })}
              >
                {tab.label}
              </div>
            </div>
          ))}
        </div>
      </nav>

      <main className="mt-4 w-full">
        {activeTab === "notes" && (
          <Notes
            notes={notes || []}
            mentorshipId={mentorship?.id}
            menteeId={mentorship?.mentee?.id}
            adminMode={adminMode}
            mentorId={mentorship?.mentor?.id}
          />
        )}

        {activeTab === "calendar" && (
          <Calendar
            mentorship={mentorship}
            notes={notes}
            sessions={sessions}
            adminMode={adminMode}
          />
        )}

        {activeTab === "contact" && (
          <Contact
            mentorship={mentorship}
            supervisor={supervisor}
            adminMode={adminMode}
          />
        )}

        {activeTab === "feedback" && <Feedback mentorshipId={mentorship.id!} />}

        {activeTab === "search" && (
          <MessageSearch mentorshipId={mentorship.id} mentorship={mentorship} />
        )}
      </main>
    </div>
  );
}
